import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useContextApi } from "../../../context/ContextApi";
import { AddIcon, XIcon } from "../../../constants/Icons";

const StockIn = ({ data, onEdit, onClose, isBtnLoading }) => {
  const [inputValue, setInputValue] = useState(data.quantity || 1);
  const [errorMessage, setErrorMessage] = useState("");
  const inputRef = useRef(null);
  const handleUpdateRef = useRef(null);
  const {useEscapeKey}=useContextApi();
  useEscapeKey(onClose)
  useEscapeKey(onClose)
  useEffect(() => {
    setInputValue(data.quantity || 1);
    setErrorMessage("");
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [data.quantity]);

  const handleUpdate = () => {
    const parsedQuantity = parseInt(inputValue, 10);
    if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
      onEdit(data, parsedQuantity);
    } else {
      setErrorMessage("Enter a valid quantity greater than 0.");
      inputRef.current.focus();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    const parsedValue = value ? parseInt(value, 10) : "";
    setInputValue(parsedValue);
    setErrorMessage("");
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const trimmedData = String(inputValue || "").trim();

      if (!trimmedData) {
        setErrorMessage((prev) => ({
          ...prev,
          [fieldName]: "Enter a valid quantity greater than 0.",
        }));
        return;
      }

      setErrorMessage((prev) => ({
        ...prev,
        [fieldName]: "",
      }));

      if (isLast) {
        handleUpdate();
      } else if (
        nextRef?.current &&
        typeof nextRef.current.focus === "function"
      ) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Stock In</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h6 className="text-center mb-2">{data.title}</h6>
              <h6 className="text-center">
                <small>Available Stock - </small>
                &nbsp;
                <span className="badge bg-label-kids">{data.stockLeft}</span>
              </h6>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <input
                  type="text"
                  value={inputValue}
                  ref={inputRef}
                  onFocus={(e) => e.target.select()}
                  onChange={handleInputChange}
                  className="form-control text-center mx-2"
                  style={{ width: "120px" }}
                  onKeyDown={(e) =>
                    handleEnterKey(e, "inputValue", handleUpdateRef, true)
                  }
                />
              </div>
              {errorMessage.inputValue && (
                <div className="text-danger text-center mt-2">
                  {errorMessage.inputValue}
                </div>
              )}
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-teal pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-teal text-right"
                  onClick={handleUpdate}
                  ref={handleUpdateRef}
                >
                  <AddIcon/> Stock In
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockIn;
